<script setup>
import SquareScore from '@/Components/Chart/SquareScore.vue';
import Card from '@/Components/Card/Card.vue';
import Pill from '@/Components/Pill.vue';

defineProps({
  transparent: Boolean
});
</script>

<template>
  <Card class="z-10 pb-4! sm:flex">
    <div class="flex flex-col items-center gap-6">
      <div class="font-bold">
        {{ $t('domain_score.partials.impersonation_card.impersonation') }}
      </div>
      <SquareScore :score="5" />
      <div>{{ $t('domain_score.partials.impersonation_card.low_risk') }}</div>
      <div class="flex flex-wrap justify-center gap-1">
        <Pill>DMARC</Pill>
        <Pill>SPF</Pill>
        <Pill>DKIM</Pill>
      </div>
    </div>
  </Card>
</template>
